<template>
    <div class="mb-5 sm:mb-9 mx-auto">
        <div class="text-center place-items-center pt-[70px] mx-2 sm:mx-auto max-w-screen-xl relative">
            <div v-if="errorMsg" class="mb-4 bg-red-200 p-4 text-red-600">
                <span>{{ errorMsg }}</span> <a href="/dashboard/user/courses" class="underline"> Courses list </a>
            </div>
            <!-- <div class="px-2 py-2 bg-green-500 text-white border w-64 rounded-full text-xl mx-auto mt-3 absolute z-10 -top-8 inset-x-0">
                See other classes
            </div> -->
            <div class="rounded-2xl shadow-xl bg-white sm:p-9 p-2 pt-9  border max-w-screen-xl">

                <div class="hidden md:block">
                    <table class="table table-striped min-w-full divide-y divide-gray-200">
                        <thead>
                        <tr>
                            <th
                                class="px-4 py-3 bg-gray-50 text-xs font-medium text-gray-500 tracking-wider"
                            >
                                Trainer
                            </th>
                            <th
                                class="px-4 py-3 bg-gray-50 text-xs font-medium text-gray-500 tracking-wider"
                            >
                                Type
                            </th>
                            <th
                                class="px-4 py-3 bg-gray-50 text-xs font-medium text-gray-500 tracking-wider"
                            >
                                Chosen date
                            </th>
                            <th
                                class="px-4 py-3 bg-gray-50 text-xs font-medium text-gray-500 tracking-wider"
                            >
                                Time zone
                            </th>
                            <th
                                class="px-4 py-3 bg-gray-50 text-xs font-medium text-gray-500 tracking-wider"
                            >
                                Course time
                            </th>
                            <th
                                class="px-4 py-3 bg-gray-50 text-xs font-medium text-gray-500 tracking-wider"
                            >
                                Price per hour
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="px-4 py-3">
                                <a :href="'/trainer/' + data.master?.id" target="_blank" class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition flex justify-center">
                                    <img class="h-12 w-12 rounded-full object-cover" :src="data.master?.user?.profile_photo_url" />
                                    <div>
                                        <div class="mt-[10px] mx-3">
                                            {{ data.master?.user?.fullName }}
                                        </div>
                                        <span class="master-level my-1"> 
                                            {{ data.master?.rate_text }}
                                        </span>
                                    </div>
                                </a>
                            </td>
                            <td class="px-4 py-3">{{ data?.course_type_text }} session</td>
                            <td class="px-4 py-3"> {{ convertDateTimeToTimezone(`${data.chosen_date} ${data.chosen_time}`, data.time_zone) }} </td>
                            <td class="px-4 py-3">{{ data.time_zone }}</td>
                            <td class="px-4 py-3">{{ data.master?.course_time }}</td>
                            <td class="px-4 py-3">{{ user.is_used_free_course ? number_format(data.amount) : 0 }}{{ currencySign }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <div class="p-3 md:hidden">
                    <div class="flex justify-start my-3">
                        <a :href="'/trainer/' + data.master?.id" target="_blank" class="flex text-sm border-2 border-transparent rounded-full focus:outline-none focus:border-gray-300 transition flex justify-center">
                            <img class="h-12 w-12 rounded-full object-cover" :src="data.master?.user?.profile_photo_url" />
                            <div>
                                <div class="mt-[10px] mx-3">
                                    {{ data.master?.user?.fullName }}
                                </div>
                                <span class="master-level my-1"> 
                                    {{ data.master?.rate_text }}
                                </span>
                            </div>
                        </a>
                    </div>
                    <div class="flex">
                        <div class="font-bold mr-2">Type : </div>
                        <div>{{ data?.course_type_text }} session</div>
                    </div>
                    <div class="flex">
                        <div class="font-bold mr-2">Chosen date : </div>
                        <div>{{ convertDateTimeToTimezone(`${data.chosen_date} ${data.chosen_time}`, data.time_zone) }}</div>
                    </div>
                    <div class="flex">
                        <div class="font-bold mr-2">Time zone : </div>
                        <div>{{ data.time_zone }}</div>
                    </div>
                    <div class="flex">
                        <div class="font-bold mr-2">Course time : </div>
                        <div>{{ data.master?.course_time }}</div>
                    </div>
                    <div class="flex">
                        <div class="font-bold mr-2">Price per hour : </div>
                        <div >{{ user.is_used_free_course ? number_format(data.amount) : 0 }}{{ currencySign }}</div>
                    </div>
                </div>
                <div class="sm:mt-9 mt-3 sm:flex block justify-around items-center">
                    <hr class="sm:hidden block sm:my-0 my-3" />
                    <div class="sm:w-2/4 w-full my-2">
                        <div class="flex justify-center items-center mb-3">
                            <span class="material-icons text-green-600 inline cursor-pointer text-[17px]" title="payment"> locks </span>
                            <a class="text-[12px] text-gray-600 text-left">
                                It is safe to pay on Happy Trainers. Payment details are encrypted and securely processed by Stripe.
                            </a>
                        </div>
                        <div class="bg-gray-200 border-1 border-gray-800 rounded-lg p-2 flex">
                            <div class="w-1/5 mx-2">
                                <img src="/storage/icon/success.png" alt="payment">
                            </div>
                            <div class="w-5/5 text-left">
                                <div class="font-bold text-gray-700">
                                    Money-Back Guarantee:
                                </div>
                                <div class="text-gray-600">
                                    We understand the importance of finding the right trainer. That’s why we offer a free consultation before booking your sessions. If you’ve had your consultation and still feel unsatisfied with your session for any reason, we’ll review your request carefully under our Terms of Service and, if eligible, provide a refund.
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="sm:hidden block sm:my-0 my-3" />
                    <div class="sm:w-1/4 w-full px-3 border-2 border-green-600">
                        <div class="flex justify-between px-20 sm:px-10">
                            <div class="tooltip-container">
                                <div class="flex justify-center items-center">
                                    <span>Transaction Fee</span>
                                    <span class="material-icons text-gray-300 inline cursor-pointer text-[15px] mx-1" title="payment"> help_outline </span>
                                </div>
                                <span class="tooltip">
                                    The transaction fee is charged by our payment provider, Stripe, for each purchase on the website.
                                </span>
                            </div>
                            <div>
                                {{ user.is_used_free_course ? data.transactionFee : 0 }}{{currencySign }}
                            </div>
                        </div>
                        <div class="flex justify-between px-20 sm:px-10">
                            <div> Total </div>
                            <div>
                                {{ user.is_used_free_course ? data.total : 0 }}{{ currencySign }}
                            </div>
                        </div>
                        <button
                            class="my-4 custom-button bg-yellow-400 text-base bg-rose-600 shadow-md px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500"
                            @click="payOrder()">
                            Pay and finalize the reservation
                        </button>
                    </div>
                    <!-- <div class="text-center">
                        <span class="text-lg">The amount payable: </span>
                        <span class="text-lg text-green-600">{{ number_format(data.amount_with_offer) }} {{ $page.props.currency }}</span>
                    </div>
                    <div>
                        <button
                            class="my-4 custom-button bg-yellow-400 text-lg bg-rose-600 shadow-md px-3 py-1 rounded-full text-white hover:shadow-xl transition duration-500 ease-in-out hover:bg-yellow-500 focus:ring focus:ring-yellow-500"
                            @click="payOrder()">
                            Pay and finalize the reservation
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myMixin from "@/myMixin";
import Button from "@/Jetstream/Button";

import {Link} from '@inertiajs/inertia-vue3'

export default {
    name: "InvoiceTemplate",
    components: {Button, Link},
    mixins: [myMixin],
    props: {
        data: Object
    },
    data() {
        return {
            errorMsg: false,
            user: this.data?.user
        }
    },
    mounted() {
        console.log('master user', this.user);
    },
    methods: {
        payOrder() {
            this.errorMsg = false;
            axios.post(route('dashboard.user.payInvoice'), {order_id: this.data.id})
            .then(response => {
                window.location.href = response.data
            })
            .catch( (response) => {
                this.errorMsg = response.response.data.message;
            })
        },
    }
}
</script>

<style scoped>

</style>
